import messageList from "./list.vue"


let a = Object.assign({ messageList });
export default a;